import {
  fieldTelusOptikTvIsThisAWinback,
  fieldTelusOptikTvMonthlyRatePlan,
  fieldTelusOptikTvPricingAndOffers,
  fieldTelusOptikTvTwoMonthFree,
  fieldInstallation,
  fieldTVBasic,
  monthlyPlanOptions,
  fieldTelusOptikTvPromoDuration
} from '../../../utils/constant';
import { getLocalizedStrings } from '../../../misc';
import getFieldValue from './getFieldValue';
import { optikTvRates, telusOptikTvPricing } from '../../../utils/rates';

const getPriceFromLabel = label => {
  const [price] = label.match(/\$\d+/) || ['0'];
  if (price) {
    return parseInt(price.replace('$', ''), 10);
  }
  return 0;
};

const getOnlyLabel = label => {
  return label.replace(/\(\$.*\)/g, '');
};

export default fields => {
  const product = {
    extraThemePacks: [],
    limitedTimeOffers: [],
    regularOffers: [],
    setTopBoxes: [],
    additionalSetTopBoxes: []
  };
  let oneTimeCharges = 0;
  const {
    contentfulValues: {
      yes,
      no,
      telusOptikTvMonthlyRatePlanOptionValues,
      telusOptikTvPricingAndOffersPromoValue,
      telusOpticTvcPVR
    },
    quoteSummary: { optikTvBoxes, mainSetTopBoxValues, mainBasicsSetTopBoxValues }
  } = getLocalizedStrings();

  let addAmountToPrice = 0;
  let subtractMonthlyAmount = 0;
  product.profile = fields.telusOptikTvProfileType;

  const telusOptikTvIsThisAWinbackValue = getFieldValue(
    fieldTelusOptikTvIsThisAWinback,
    fields
  );
  const telusOptikTvPromoDurationValue = getFieldValue(
    fieldTelusOptikTvPromoDuration,
    fields
  );
  const valuePromoDuration = telusOptikTvPricing.promoDurationOptikTV[telusOptikTvPromoDurationValue];
  const telusOptikTvMonthlyRatePlanValue = getFieldValue(
    fieldTelusOptikTvMonthlyRatePlan,
    fields
  );
  const installationValue = getFieldValue(fieldInstallation, fields);
  const telusOptikTvMonthlyRatePlanMonthlyPrice =
    optikTvRates[telusOptikTvMonthlyRatePlanValue];
  const telusOptikTvOneTimeCharges =
    telusOptikTvPricing.winBackNoPrice[installationValue];
  product.ratePlan = {
    value: telusOptikTvMonthlyRatePlanValue,
    qty: 1,
    prices: {
      monthly: telusOptikTvMonthlyRatePlanMonthlyPrice,
      oneTime:
        (telusOptikTvIsThisAWinbackValue === no &&
          telusOptikTvOneTimeCharges) ||
        0
    }
  };
  addAmountToPrice += telusOptikTvMonthlyRatePlanMonthlyPrice;
  if (telusOptikTvIsThisAWinbackValue === no) {
    oneTimeCharges += telusOptikTvOneTimeCharges;
  }
  if (fields.telusOptikTvAdditionalThemePacks) {
    const additionalThemePacks = fields.telusOptikTvAdditionalThemePacks.map(
      pack => {
        const price = getPriceFromLabel(pack);
        addAmountToPrice += price;
        return {
          value: getOnlyLabel(pack),
          qty: 1,
          prices: {
            monthly: price,
            oneTime: 0
          }
        };
      }
    );
    product.additionalThemePacks = additionalThemePacks;
  }
  if (fields.telusOptikTvAdditionalThemePacksHomeBased) {
    const additionalThemePacksHomeBased = fields.telusOptikTvAdditionalThemePacksHomeBased.map(
      pack => {
        const price = getPriceFromLabel(pack);
        addAmountToPrice += price;
        return {
          value: getOnlyLabel(pack),
          qty: 1,
          prices: {
            monthly: price,
            oneTime: 0
          }
        };
      }
    );
    product.additionalThemePacksHomeBased = additionalThemePacksHomeBased;
  }
  if (fields.telusOptikTvFreeThemePacks) {
    const freeThemePacks = fields.telusOptikTvFreeThemePacks.map(pack => ({
      value: getOnlyLabel(pack),
      qty: 1,
      prices: {
        monthly: getPriceFromLabel(pack),
        oneTime: 0
      }
    }));
    product.freeThemePacks = freeThemePacks;
  }
  if (fields.telusOptikTvFreeThemePacksForHomeBased) {
    const freeThemePacksHomeBased = fields.telusOptikTvFreeThemePacksForHomeBased.map(
      pack => ({
        value: getOnlyLabel(pack),
        qty: 1,
        prices: {
          monthly: getPriceFromLabel(pack),
          oneTime: 0
        }
      })
    );
    product.freeThemePacksHomeBased = freeThemePacksHomeBased;
  }

  if (fields.telusOptikTvExtraThemePackHomeBased) {
    const extraThemePacksHomeBased = fields.telusOptikTvExtraThemePackHomeBased.map(
      pack => {
        const price = getPriceFromLabel(pack);
        addAmountToPrice += price;
        return {
          value: getOnlyLabel(pack),
          qty: 1,
          prices: {
            monthly: price,
            oneTime: 0
          }
        };
      }
    );
    product.extraThemePacksHomeBased = extraThemePacksHomeBased;
  }

  if (fields.telusOptikTvExtraThemePackMulticultural) {
    const extraThemePacks = fields.telusOptikTvExtraThemePackMulticultural.map(
      pack => {
        const price = getPriceFromLabel(pack);
        addAmountToPrice += price;
        return {
          value: getOnlyLabel(pack),
          qty: 1,
          prices: {
            monthly: price,
            oneTime: 0
          }
        };
      }
    );
    product.extraThemePacks = extraThemePacks;
  }
  if (fields.telusOptikTvNumberWiredSetTopBoxes) {
    let wirelinePrice = 0;
    if (fields.telusOptikTvNumberWiredSetTopBoxes > 0 && (telusOptikTvMonthlyRatePlanValue === fieldTVBasic || monthlyPlanOptions.includes(telusOptikTvMonthlyRatePlanValue) )) {
      wirelinePrice =
        telusOptikTvPricing.topBoxes[telusOptikTvMonthlyRatePlanValue]
  }
    if (fields.telusOptikTvNumberWiredSetTopBoxes > 1 && !(telusOptikTvMonthlyRatePlanValue === fieldTVBasic || monthlyPlanOptions.includes(telusOptikTvMonthlyRatePlanValue) )) {
      wirelinePrice = 0
    }
    product.setTopBoxes.push({
      value: `${optikTvBoxes.wired} Rent`,
      qty: 1,
      prices: {
        monthly: wirelinePrice,
        oneTime: 0
      }
    });
    addAmountToPrice += wirelinePrice;
  }
  if (fields.telusOptikTvNumberWiredSetTopBoxes > 1) {
    let wirelinePrice = 0;
    if (fields.telusOptikTvNumberWiredSetTopBoxes > 1) {
      wirelinePrice =
        telusOptikTvPricing.topBoxes[telusOptikTvMonthlyRatePlanValue] *
        (fields.telusOptikTvNumberWiredSetTopBoxes - 1);
    }
    product.setTopBoxes.push({
      value: `${optikTvBoxes.wired} Rent`,
      qty: fields.telusOptikTvNumberWiredSetTopBoxes -1,
      prices: {
        monthly: wirelinePrice,
        oneTime: 0
      }
    });
    addAmountToPrice += wirelinePrice;
  }
  if (fields.telusOptikTvNumberWirelessSetTopBoxes > 0) {
    const wirelessPrice = telusOptikTvPricing.topBoxes[telusOptikTvMonthlyRatePlanValue] * fields.telusOptikTvNumberWirelessSetTopBoxes;
    product.setTopBoxes.push({
      value: `${optikTvBoxes.wireless} Rent`,
      qty: fields.telusOptikTvNumberWirelessSetTopBoxes,
      prices: {
        monthly: wirelessPrice,
        oneTime: 0
      }
    });
    addAmountToPrice += wirelessPrice;
  }
  if (fields.telusOptikTvMainSetTopBox) {
    const isMonthly =
      fields.telusOptikTvMainSetTopBox === mainSetTopBoxValues.rent;
    product.mainSetTopBox = {
      value: getOnlyLabel(fields.telusOptikTvMainSetTopBox),
      qty: 1,
      prices: {
        monthly: isMonthly
          ? getPriceFromLabel(fields.telusOptikTvMainSetTopBox)
          : 0,
        oneTime: !isMonthly
          ? getPriceFromLabel(fields.telusOptikTvMainSetTopBox)
          : 0
      }
    };
    oneTimeCharges +=
      (!isMonthly && getPriceFromLabel(fields.telusOptikTvMainSetTopBox)) || 0;
    addAmountToPrice +=
      (isMonthly && getPriceFromLabel(fields.telusOptikTvMainSetTopBox)) || 0;
  }
  if (fields.telusOptikTvBasicsMainSetTopBox) {
    const isMonthly =
      fields.telusOptikTvBasicsMainSetTopBox === mainBasicsSetTopBoxValues.rent;
    product.mainSetTopBox = {
      value: getOnlyLabel(fields.telusOptikTvBasicsMainSetTopBox),
      qty: 1,
      prices: {
        monthly: isMonthly
          ? getPriceFromLabel(fields.telusOptikTvBasicsMainSetTopBox)
          : 0,
        oneTime: !isMonthly
          ? getPriceFromLabel(fields.telusOptikTvBasicsMainSetTopBox)
          : 0
      }
    };
    oneTimeCharges +=
      (!isMonthly && getPriceFromLabel(fields.telusOptikTvBasicsMainSetTopBox)) || 0;
    addAmountToPrice +=
      (isMonthly && getPriceFromLabel(fields.telusOptikTvBasicsMainSetTopBox)) || 0;
  }
  if (
    fields.telusOptikTvAdditionalSetTopBoxes &&
    fields.telusOptikTvAdditionalSetTopBoxes.length > 0
  ) {
    fields.telusOptikTvAdditionalSetTopBoxes.forEach(
      ({ telusOptikTvAdditionalSetTopBox }) => {
        const isMonthly =
          telusOptikTvAdditionalSetTopBox === mainSetTopBoxValues.rent ||
          telusOptikTvAdditionalSetTopBox === mainSetTopBoxValues.rent10Dollar;
        const setTopBox = {
          value: getOnlyLabel(telusOptikTvAdditionalSetTopBox),
          qty: 1,
          prices: {
            monthly: isMonthly
              ? getPriceFromLabel(telusOptikTvAdditionalSetTopBox)
              : 0,
            oneTime: !isMonthly
              ? getPriceFromLabel(telusOptikTvAdditionalSetTopBox)
              : 0
          }
        };
        product.additionalSetTopBoxes.push({ ...setTopBox });
        oneTimeCharges +=
          (!isMonthly && getPriceFromLabel(telusOptikTvAdditionalSetTopBox)) ||
          0;
        addAmountToPrice +=
          (isMonthly && getPriceFromLabel(telusOptikTvAdditionalSetTopBox)) ||
          0;
      }
    );
  }
  const telusOptikTvPricingAndOffersValue = getFieldValue(
    fieldTelusOptikTvPricingAndOffers,
    fields
  );
  const telusOptikTvTwoMonthFreeValue = getFieldValue(
    fieldTelusOptikTvTwoMonthFree,
    fields
  );

  if (
    [
      telusOptikTvMonthlyRatePlanOptionValues.tv,
      telusOptikTvMonthlyRatePlanOptionValues.tvElite
    ].includes(telusOptikTvMonthlyRatePlanValue) &&
    telusOptikTvPricingAndOffersValue ===
      telusOptikTvPricingAndOffersPromoValue &&
    (!telusOptikTvTwoMonthFreeValue || telusOptikTvTwoMonthFreeValue === no)
  ) {
    product.regularOffers.push({
      value: telusOptikTvPricingAndOffersPromoValue,
      qty: 1,
      prices: {
        monthly: -10,
        oneTime: 0
      }
    });
    subtractMonthlyAmount += 10;
  }
  if (telusOptikTvPricingAndOffersValue.includes(telusOptikTvPricingAndOffersPromoValue)) {
    product.regularOffers.push({
      value: valuePromoDuration,
      qty: 1,
      prices: {
        monthly: -10,
        oneTime: 0
      }
    });
    subtractMonthlyAmount += 10;
  }
  if (
    telusOptikTvPricingAndOffersValue.includes(telusOpticTvcPVR)
  ) {
    product.regularOffers.push({
      value: telusOpticTvcPVR,
      qty: 1,
      prices: {
        monthly: 10,
        oneTime: 0
      }
    });
    addAmountToPrice += 10;
  }

  if (
    telusOptikTvPricingAndOffersValue ===
      telusOptikTvPricingAndOffersPromoValue &&
    telusOptikTvTwoMonthFreeValue === yes
  ) {
    product.regularOffers.push({
      value: telusOptikTvPricingAndOffersPromoValue,
      qty: 1,
      prices: {
        monthly: -telusOptikTvMonthlyRatePlanMonthlyPrice,
        oneTime: 0
      }
    });
    subtractMonthlyAmount += telusOptikTvMonthlyRatePlanMonthlyPrice;
  }

  return {
    ...product,
    totalMonthly: addAmountToPrice - subtractMonthlyAmount,
    totalOneTime: oneTimeCharges
  };
};
